// extracted by mini-css-extract-plugin
export default {"container":"SearchForm_container__-V+Vp"};